// School campus center — zip 48304, Bloomfield Hills, Michigan
export const CAMPUS_CENTER = [42.5834, -83.2455];

export const HERO_IMAGE =
  "https://lh3.googleusercontent.com/d/13oNU0C2vdcO2d2D3AHYFWamuPBQjmuub=w2400";
